export const UNKNOWN_ERROR = 'UNKNOWN_ERROR';
export const CONFLICTING_CONTACT_EMAIL_VALUE = 'CONFLICTING_CONTACT_EMAIL_VALUE';
export const INVALID_EMAIL_FORMAT = 'INVALID_EMAIL_FORMAT';
export const INVALID_DOMAIN_FORMAT = 'INVALID_DOMAIN_FORMAT';
export const INVALID_NAME_WITH_QUOTES = 'INVALID_NAME_WITH_QUOTES';
export const INVALID_BILLING_TERM_FREQUENCY_RATIO = 'INVALID_BILLING_TERM_FREQUENCY_RATIO';
export const INVALID_FILE_VALUE = 'INVALID_FILE_VALUE';